import c from "classnames";
import { PropsWithChildren, ReactNode } from "react";

import classes from "./InputBox.module.css";

type Props = PropsWithChildren<{
  leftOnClick?: () => void;
  rightOnClick?: () => void;
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
  wrap?: boolean;
}>;

export const InputBox = ({
  leftOnClick,
  rightOnClick,
  leftSlot,
  children,
  rightSlot,
  wrap = true,
  ...rest
}: Props) => {
  return (
    <div className={c(classes.inputBox, wrap && classes.wrap)} {...rest}>
      {leftSlot ? (
        <div className={c(classes.leftSlot, wrap && classes.wrap)} onClick={leftOnClick ? leftOnClick : undefined}>{leftSlot}</div>
      ) : null}
      {children}
      <div onClick={rightOnClick ? rightOnClick : undefined}>{rightSlot}</div>
    </div>
  );
};
